import { Controller } from "@hotwired/stimulus"

// Decorative only: no form submissions, storage or external requests.
export default class extends Controller {
  static targets = ["confetti"]

  connect() {
    this.animations = []
    this.motion = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.handleMotionChange = () => { if (this.motion.matches) this.finish() }
    this.motion.addEventListener("change", this.handleMotionChange)
    this.element.classList.remove("is-celebrating", "is-celebrated")
    this.confettiTarget.replaceChildren()
    this.papers = Array.from({ length: 36 }, (_, index) => {
      const element = document.createElement("span")
      element.className = "journey-confetti__piece"
      element.style.setProperty("--paper-color", ["#ffc400", "#ff8a18", "#f9589d", "#31c8ef", "#9c78f7", "#34d399"][index % 6])
      this.confettiTarget.append(element)
      const angle = index * 137.5 * Math.PI / 180
      const radius = 85 + (index % 7) * 13
      return { element, x: Math.cos(angle) * radius, y: Math.sin(angle) * radius * .45,
        rotation: 150 + (index * 41) % 230, duration: 1500 + (index * 73) % 300 }
    })
    this.frame = window.requestAnimationFrame(() => this.play())
  }

  disconnect() {
    window.cancelAnimationFrame(this.frame)
    this.stop()
    this.motion.removeEventListener("change", this.handleMotionChange)
  }

  play() {
    this.stop()
    if (this.motion.matches) return this.finish()
    this.element.classList.remove("is-celebrated")
    this.element.classList.add("is-celebrating")
    this.animations = this.papers.map(paper => paper.element.animate(this.frames(paper), {
      duration: paper.duration, easing: "linear", fill: "both"
    }))
  }

  frames(paper) {
    // One continuous drag/gravity trajectory; no easing resets at waypoints.
    return Array.from({ length: 81 }, (_, index) => {
      const t = index / 80
      const spread = (1 - Math.exp(-3 * t)) / (1 - Math.exp(-3))
      const fade = Math.max(0, Math.min(1, (t - .4) / .6))
      return { offset: t, opacity: Math.min(1, t / .05) * (1 - fade * fade * (3 - 2 * fade)),
        transform: `translate(${paper.x * spread}px, ${paper.y * spread + 150 * t * t}px) rotate(${paper.rotation * t}deg) rotateY(${120 * t}deg) scale(${.7 + .3 * spread})` }
    })
  }

  stop() {
    this.animations.forEach(animation => animation.cancel())
    this.animations = []
  }

  finish() {
    window.cancelAnimationFrame(this.frame)
    this.stop()
    this.element.classList.remove("is-celebrating")
    this.element.classList.add("is-celebrated")
  }
}
